'use strict';

var chunkHIHYWLJZ_js = require('./chunk-HIHYWLJZ.js');
var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

var u=({imgUrl:s,altText:o,overlay:m,children:c,className:r,...d})=>{let f=r||"",[t,g]=react.useState(0),a=react.useRef(null);return react.useEffect(()=>{g(a.current?.children[0]?.clientHeight+128);},[]),jsxRuntime.jsxs("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-hero-banner ${f}`),style:{gridTemplateRows:t&&chunkHIHYWLJZ_js.a(t)},...d,children:[jsxRuntime.jsx("div",{className:"banner-image-div",children:jsxRuntime.jsx("img",{className:"banner-image",src:s,alt:o,loading:"lazy"})}),jsxRuntime.jsx("div",{className:`${m?"banner-overlay-div":""}`}),jsxRuntime.jsx("div",{className:"banner-child",ref:a,children:c})]})},b=u;

exports.a = b;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-FRUWSHYC.js.map